import { useEffect } from 'react';

export const useReportPendingState = (isPending, onPendingChange) => {
  useEffect(() => {
    onPendingChange?.(Boolean(isPending));
    return () => onPendingChange?.(false);
  }, [isPending, onPendingChange]);
};
